import { Record } from 'immutable';

export default class EmploymentNumberRecord extends Record({
  id: undefined,
  createdAt: undefined,
  customEmploymentNumber: undefined,
  employmentNumber: undefined,
  staffingCompany: undefined,
}) {
}
